// Google Analytics 工具函數

// GA 測量 ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-EEYX0LFXW0';

// 初始化 Google Analytics
export const initGA = () => {
  if (typeof window === 'undefined') return;

  // 如果沒有設定測量 ID，就不載入 GA
  if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID === 'G-XXXXXXXXXX') {
    console.log('⚠️ Google Analytics 測量 ID 尚未設定');
    return;
  }

  // 載入 GA4 script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // 初始化 gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false // 我們會手動發送頁面瀏覽事件
  });

  console.log('✅ Google Analytics 已初始化:', GA_MEASUREMENT_ID);
};

// 發送頁面瀏覽事件
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle
  });
};

// 發送自訂事件
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', eventName, eventParams);
  console.log('📊 GA Event:', eventName, eventParams);
};

// 顯示器專用追蹤事件

// 追蹤顯示器登入
export const trackDisplayLogin = (displayId, displayName) => {
  trackEvent('display_login', {
    display_id: displayId,
    display_name: displayName,
    timestamp: new Date().toISOString()
  });
};

// 追蹤內容播放
export const trackContentPlay = (displayId, contentType, contentData) => {
  trackEvent('content_play', {
    display_id: displayId,
    content_type: contentType,
    ...contentData,
    timestamp: new Date().toISOString()
  });
};

// 追蹤計時器顯示
export const trackTimerDisplay = (displayId, timerId, timerName) => {
  trackEvent('timer_display', {
    display_id: displayId,
    timer_id: timerId,
    timer_name: timerName,
    timestamp: new Date().toISOString()
  });
};

// 追蹤輪播播放
export const trackCarouselPlay = (displayId, carouselData) => {
  trackEvent('carousel_play', {
    display_id: displayId,
    carousel_id: carouselData.carouselId,
    carousel_name: carouselData.carouselName,
    item_index: carouselData.itemIndex,
    item_type: carouselData.itemType,
    timestamp: new Date().toISOString()
  });
};

// 追蹤 session 時長（每 30 秒）
export const trackSessionDuration = (displayId, sessionDuration) => {
  trackEvent('session_heartbeat', {
    display_id: displayId,
    session_duration: sessionDuration,
    timestamp: new Date().toISOString()
  });
};

// 追蹤顯示器刷新
export const trackDisplayRefresh = (displayId, reason) => {
  trackEvent('display_refresh', {
    display_id: displayId,
    refresh_reason: reason,
    timestamp: new Date().toISOString()
  });
};
